import { render, staticRenderFns } from "./StaffDailyAttendance.vue?vue&type=template&id=271b3814&scoped=true&"
import script from "./StaffDailyAttendance.vue?vue&type=script&lang=js&"
export * from "./StaffDailyAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b3814",
  null
  
)

export default component.exports